import { BitkitLink, IconBitbot } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import URLs from '@/enums/urls';

import BitriseStatus from '../BitriseStatus/BitriseStatus';

const links = [
  {
    label: 'Docs',
    url: URLs.DOCUMENTATION,
  },
  {
    label: 'API',
    url: URLs.API_DOCUMENTATION,
  },
  {
    label: 'Pricing',
    url: URLs.PRICING,
  },
  {
    label: 'Security',
    url: URLs.SECURITY_POLICY,
  },
  {
    label: 'Terms',
    url: URLs.TERMS_OF_SERVICE,
  },
  {
    label: 'Privacy',
    url: URLs.PRIVACY_POLICY,
  },
  {
    label: 'Cookie',
    url: URLs.COOKIE_POLICY,
  },
];

const InternalFooter = ({
  hasSidebar,
  variant = 'regular',
  ...props
}: BoxProps & { hasSidebar?: boolean; variant?: 'regular' | 'transparent' }) => {
  const currentYear = new Date().getFullYear();
  const paddingForIntercomWidget = '5rem';
  const textColor = variant === 'regular' ? 'text/secondary' : 'color/purple/muted';
  return (
    <Box
      display="flex"
      id="footer"
      as="footer"
      background="background/secondary"
      marginLeft={hasSidebar ? ['0', '16.625rem'] : undefined}
      paddingX="12"
      paddingY="16"
      flexDirection={{ base: 'column', desktop: 'row' }}
      alignItems="center"
      {...props}
    >
      <Box
        display="flex"
        paddingY={{ desktop: '0', base: '16' }}
        justifyContent={['center', 'flex-start']}
        flex={1}
        marginRight={{ desktop: 'auto', base: '0' }}
        height="32"
      >
        <BitriseStatus />
      </Box>
      <Box display="flex" justifyContent="center" flex={1} gap="8" alignItems="center">
        <IconBitbot color={variant === 'regular' ? 'icon/secondary' : 'icon/on-color'} />
        <Text textStyle="body/md/regular" color={textColor}>
          © {currentYear} Bitrise Ltd.
        </Text>
      </Box>
      <Box
        display="flex"
        flex={1}
        order={{ desktop: '0', base: '-1' }}
        marginLeft={{ desktop: 'auto', base: '0' }}
        gap="8"
        paddingRight={{ desktop: paddingForIntercomWidget, base: '0' }}
        justifyContent={['center', 'flex-end']}
      >
        {links.map((link) => (
          <BitkitLink key={link.label} href={link.url} textStyle="body/md/regular" color={textColor} isExternal>
            {link.label}
          </BitkitLink>
        ))}
      </Box>
    </Box>
  );
};

export default InternalFooter;
